var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0312 10.7344C20.0312 16.2812 16.2422 20.1875 10.6562 20.1875C5.26562 20.1875 0.96875 15.8906 0.96875 10.5C0.96875 5.14844 5.26562 0.8125 10.6562 0.8125C13.2344 0.8125 15.4609 1.78906 17.1406 3.35156L14.4844 5.89062C11.0469 2.57031 4.64062 5.07031 4.64062 10.5C4.64062 13.8984 7.33594 16.6328 10.6562 16.6328C14.4844 16.6328 15.9297 13.8984 16.125 12.4531H10.6562V9.13281H19.875C19.9531 9.64062 20.0312 10.1094 20.0312 10.7344Z",
    fill: "#575759"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGg);
export default __webpack_public_path__ + "static/media/_gg.6f3dc2427d8adb9fc383e258162f239f.svg";
export { ForwardRef as ReactComponent };